import { ArtistGenreUnionType, useCreateArtist } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { AddArtistFormSchemaType } from '../useAddArtistForm';

const TRANS_KEY = 'NOTIFICATIONS.ADD_ARTIST';

type UseSubmitNewArtistReturnType = {
  submitNewArtist: (data: AddArtistFormSchemaType) => void;
};

export const useSubmitNewArtist = (): UseSubmitNewArtistReturnType => {
  const { mutateAsync: createArtist } = useCreateArtist();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitNewArtist = async (data: AddArtistFormSchemaType) => {
    return createArtist(
      {
        data: {
          ...data,
          abbreviation: data.abbreviation || null,
          artistLink: data.artistLink || null,
          website: data.website || null,
          genres: data.genres as ArtistGenreUnionType[],
          comment: data.comment || null,
        },
      },
      { onSuccess, onError }
    );
  };

  return { submitNewArtist };
};
